import { BLOCKS } from '@contentful/rich-text-types'
import Image from 'next/image'
import { IMAGE_BLUR_URL } from '../../utils/constants'
import VideoPlayer from '../VideoPlayer/VideoPlayer'
import style from '../../styles/components/static-pages'

export const renderOptions = {
  renderNode: {
    [BLOCKS.EMBEDDED_ASSET]: (node) => {
      const assetType = node?.data?.target?.fields?.file?.contentType

      switch (assetType) {
        case 'image/png':
        case 'image/gif':
        case 'image/jpeg':
          return (
            <>
              <div className='image-wrapper'>
                <Image
                  src={`https://${node.data.target.fields.file.url}`}
                  width={node.data.target.fields.file.details.image.width}
                  height={node.data.target.fields.file.details.image.height}
                  alt={node.data.target.fields.description}
                  placeholder='blur'
                  blurDataURL={IMAGE_BLUR_URL}
                />
                <div className='caption'>{node.data.target.fields.description}</div>
              </div>
              <style jsx>{style}</style>
            </>
          )

        case 'video/mp4':
          return (
            <>
              <div className='video-embed'>
                <VideoPlayer
                  video={{
                    src: `https://${node.data.target.fields.file.url}#t=0.001`,
                    type: node.data.target.fields.file.contentType,
                    isLive: false
                  }}
                />
              </div>
              <style jsx>{style}</style>
            </>
          )
      }
    }
  }
}
